import React from 'react';
import { Tabs, Tab, Paper } from '@mui/material';
import MDBox from 'src/components/md/MDBox';
import { TABS_SX } from '../utils';
import { tabLabel } from './ViewerUtils';
import {
  ResizablePanelGroup,
  ResizablePanel,
  ResizableHandle,
} from 'src/components/ui/resizable';

export interface TopBottomViewProps {
  originalDataViewer: React.ReactNode;
  transformedDataViewer: React.ReactNode;
  isLoadingOriginal: boolean;
  isLoadingTransformed: boolean;
  originalTitle?: string;
  transformedTitle?: string;
}

export default function TopBottomView({
  originalDataViewer,
  transformedDataViewer,
  isLoadingOriginal,
  isLoadingTransformed,
  originalTitle,
  transformedTitle,
}: TopBottomViewProps) {
  return (
    <ResizablePanelGroup direction="vertical" style={{ height: '100%' }}>
      {/* Original Data Section - Top Panel */}
      <ResizablePanel defaultSize={50} minSize={20}>
        <Paper
          elevation={2}
          sx={{
            height: '100%',
            border: '1px solid',
            borderColor: 'info.main',
            borderRadius: 2,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Tabs
            value={false}
            sx={{
              ...TABS_SX,
              minHeight: 'auto',
              height: '48px',
              flexShrink: 0,
            }}
          >
            <Tab
              label={tabLabel(
                originalTitle || 'Original Data',
                isLoadingOriginal,
              )}
            />
          </Tabs>
          <MDBox flex="1 1 auto" overflow="auto">
            {originalDataViewer}
          </MDBox>
        </Paper>
      </ResizablePanel>

      <ResizableHandle />

      {/* Transformed Data Section - Bottom Panel */}
      <ResizablePanel defaultSize={50} minSize={20}>
        <Paper
          elevation={2}
          sx={{
            height: '100%',
            border: '1px solid',
            borderColor: 'info.main',
            borderRadius: 2,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Tabs
            value={false}
            sx={{
              ...TABS_SX,
              minHeight: 'auto',
              height: '48px',
              flexShrink: 0,
            }}
          >
            <Tab
              label={tabLabel(
                transformedTitle || 'Transformed Data',
                isLoadingTransformed,
              )}
            />
          </Tabs>
          <MDBox flex="1 1 auto" overflow="auto">
            {transformedDataViewer}
          </MDBox>
        </Paper>
      </ResizablePanel>
    </ResizablePanelGroup>
  );
}
